import { createApp } from 'vue';
import Http from 'axios';
import Router from '@app/router';
import Tracking from '@app/tracking';
import Helpers from '@app/global/helpers';
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome';
import EventTrackingDirective from '@app/directives/eventTracking';
import ContentParserDirective from '@app/directives/contentParser';
import FocusAreaDirective from '@app/directives/focusArea';
import ObserverDirective from '@app/directives/observe';
import ButtonRippleDirective from '@app/directives/ripple';
import ClickOutsideDirective from '@app/directives/clickOutside';
import '@app/global/web-vitals';
import '@app/global/icons';
import '@app/modules/Racerfish/Evolve';
// import '@app/modules/Racerfish/Blog'
// import '@app/modules/Racerfish/Event'
import '@app/modules/Racerfish/Company';
// import '@app/modules/Racerfish/Locator'
// import '@app/modules/Racerfish/Member'
import '@app/modules/Racerfish/Scout24';
// import '@app/modules/Racerfish/Search'
// import '@app/modules/Racerfish/Shopify'
import AppGlobals from '@app/plugins/AppGlobals';
import AppComponent from '@app/components/App.vue';
import UIContainer from '@app/components/UI/Layout/Container.vue';
import UIStack from '@app/components/UI/Layout/Stack.vue';
import UIGridRow from '@app/components/UI/Layout/GridRow.vue';
import UIGridColumn from '@app/components/UI/Layout/GridColumn.vue';
import UILink from '@app/components/UI/Link.vue';
import UISpinner from '@app/components/UI/Spinner.vue';
import UIResponsiveImage from '@app/components/UI/ResponsiveImage.vue';
import UIButton from '@app/components/UI/Button.vue';
const App = createApp(AppComponent);
App.use(AppGlobals);
App.use(Router);
App.directive('track', EventTrackingDirective);
App.directive('parse-content', ContentParserDirective);
App.directive('focus', FocusAreaDirective);
App.directive('observe', ObserverDirective);
App.directive('ripple', ButtonRippleDirective);
App.directive('click-outside', ClickOutsideDirective);
App.component('ui-stack', UIStack);
App.component('ui-container', UIContainer);
App.component('ui-row', UIGridRow);
App.component('ui-col', UIGridColumn);
App.component('ui-link', UILink);
App.component('ui-spinner', UISpinner);
App.component('ui-responsive-image', UIResponsiveImage);
App.component('ui-button', UIButton);
App.component('fa-icon', FontAwesomeIcon);
App.component('fa-layers', FontAwesomeLayers);
App.component('fa-layers-text', FontAwesomeLayersText);
// Add Laravel CSRF token to axios defaults
const csrfMeta = document.querySelector('meta[name="csrf-token"]');
if (csrfMeta) {
    Http.defaults.headers.common['X-CSRF-TOKEN'] = csrfMeta.getAttribute('content');
    Http.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
}
else {
    throw new Error('CSRF Token meta tag not found');
}
// Remove static javascript for language and frontend user initializing
const jsInitEl = document.getElementById('jsInit');
if (jsInitEl && jsInitEl.parentNode) {
    jsInitEl.parentNode.removeChild(jsInitEl);
}
// Start tracking if consent was given or unkonwn
const cookieConsent = Helpers.storage.get('cookie-consent-given');
if (!cookieConsent || cookieConsent == 'yes') {
    Tracking.start();
}
Router.isReady().then(() => App.mount('#app'));
export default App;
